webpackJsonp([18],{

/***/ 118:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 119:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 120:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 121:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(120)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(76),
  /* template */
  __webpack_require__(133),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(121)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(134),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 131:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 132:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fadeLoading"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoading),
      expression: "showLoading"
    }],
    staticClass: "loading"
  }, [_c('img', {
    attrs: {
      "src": "https://img.chezhentong.com/loading-spokes.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("数据加载中....")])])])
},staticRenderFns: []}

/***/ }),

/***/ 133:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('touch', {
    staticClass: "picker-item",
    on: {
      "panstart": _vm.onPanStart,
      "panmove": _vm.onPanMove,
      "panend": _vm.onPanEnd
    }
  }, [_c('div', {
    directives: [{
      name: "for-nested",
      rawName: "v-for-nested",
      value: ([_vm.currentValues, _vm.keyName]),
      expression: "[currentValues, keyName]"
    }],
    ref: "pickerItemContent",
    staticClass: "picker-item-content",
    style: ({
      transform: 'rotateX(' + _vm.scrollValue + 'deg)'
    })
  })])
},staticRenderFns: []}

/***/ }),

/***/ 134:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "picker"
    }
  }, [_c('touch', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "picker-backdrop",
    on: {
      "tap": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "picker-wrapper"
  }, [_vm._t("top-content"), _vm._v(" "), _c('div', {
    staticClass: "picker-content"
  }, [_c('div', {
    staticClass: "picker-body"
  }, _vm._l((_vm.dataItems), function(item, index) {
    return _c('picker-item', {
      key: index,
      style: (item.style),
      attrs: {
        "itemIndex": index,
        "index": item.index,
        "all-values": item.values,
        "values": item.$value,
        "length": item.values.length - 1,
        "maxScrollValue": item.maxScrollValue,
        "keyName": item.key
      },
      on: {
        "change": _vm.onChangeValue
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "picker-helper"
  })]), _vm._v(" "), _vm._t("bottom-content")], 2)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(135);



var register = function register(resolve) {
  return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(141)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var home = function home(resolve) {
  return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(145)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var index = function index(resolve) {
  return __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(146)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var agreement = function agreement(resolve) {
  return __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(143)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var notFound = function notFound(resolve) {
  return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(149)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var mineVoucher = function mineVoucher(resolve) {
  return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(147)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var doneOrder = function doneOrder(resolve) {
  return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(151)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var orderDetail = function orderDetail(resolve) {
  return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(150)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var scorePage = function scorePage(resolve) {
  return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(152)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var useVoucher = function useVoucher(resolve) {
  return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(155)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var voucherExplain = function voucherExplain(resolve) {
  return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(154)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var voucherDetail = function voucherDetail(resolve) {
  return __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(153)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var xuefulanIndex = function xuefulanIndex(resolve) {
  return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(156)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var loading = __webpack_require__(56);
var follow = function follow(resolve) {
  return __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(140)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var debug = function debug(resolve) {
  return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(142)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var mooring = function mooring(resolve) {
  return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(148)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var baoLide = function baoLide(resolve) {
  return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(144)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: "history",
  routes: [{
    path: "/register",
    name: "register",
    component: register
  }, {
    path: "/mooring",
    name: "mooring",
    component: mooring
  }, {
    path: "/home",
    name: "home",
    component: home
  }, {
    path: "/index",
    name: "index",
    component: index
  }, {
    path: "/index/:type",
    component: index
  }, {
    path: "/agreement",
    name: "agreement",
    component: agreement
  }, {
    path: "/mine/voucher",
    name: "mineVoucher",
    component: mineVoucher
  }, {
    path: "/",
    component: index
  }, {
    path: "/order/done",
    name: "doneOrder",
    component: doneOrder
  }, {
    path: "/order/done/mooring",
    name: "mooring",
    component: mooring
  }, {
    path: "/order/done/baoLide",
    name: "baoLide",
    component: baoLide
  }, {
    path: "/baoLide",
    name: "baoLide",
    component: baoLide
  }, {
    // 避免路由跳转带来闪屏增加路由
    path: "/order/done/chevrolet",
    name: "xuefulanIndex",
    component: xuefulanIndex
  }, {
    path: "/order/done/:type",
    name: "doneOrder",
    component: doneOrder
  }, {
    //保留路由(涉及支付、模版消息)
    path: "/detail/:id",
    name: "orderDetail",
    component: orderDetail
  }, {
    path: "/order/score",
    name: "scorePage",
    component: scorePage
  }, {
    path: "/voucher/use/:price",
    name: "useVoucher",
    component: useVoucher
  }, {
    path: "/voucher/explain/:token",
    name: "voucherExplain",
    component: voucherExplain
  }, {
    path: "/voucher/detail/:token",
    name: "voucherDetail",
    component: voucherDetail
  }, {
    path: "/xuefulan/index",
    name: "xuefulanIndex",
    component: xuefulanIndex
  }, {
    path: "/debug",
    name: "debug",
    component: debug
  }, {
    path: "/loading",
    name: "loading",
    component: loading
  }, {
    path: "/follow",
    name: "follow",
    component: follow
  }, {
    path: "*",
    name: "index",
    component: index
  }]
});
//全局钩子
router.beforeEach(function (to, form, next) {
  //统计代码
  if (to.path.indexOf("/detail") > -1) {
    ga("send", "pageview", "/detail");
  } else {
    if (to.query && to.query.from) {
      ga("send", "pageview", to.fullPath);
    } else {
      ga("send", "pageview", to.path);
    }
  }
  // 测试配置
  if (to.query.e && to.query.e == "t") {
    localStorage.OpenId = "oXanAvueZJjlVWFlQoScAxav0Cvs";
    // next()
  }
  if (to.query.Scen_str) {
    localStorage.Scen_str = to.query.Scen_str;
  }
  if (to.query.s) {
    localStorage.s = to.query.s;
  }

  var path = /^#(\/[^\?\=\&]*)/.exec(location.hash) ? /^#(\/[^\?\=\&]*)/.exec(location.hash)[1] : to.path;

  if (window.location.href.indexOf("/#") >= 0) {
    window.location.href = window.location.href.replace("/#", "");
  }

  //通过code换取openid
  var code = typeof to.query.code == "string" || typeof to.query.code == "undefined" ? to.query.code : to.query.code[0];
  if (to.query.code) {
    axios.get("openid?code=" + code).then(function (response) {
      if (response.data.errcode == 0 && response.data.openid) {
        localStorage.OpenId = response.data.openid;
        // 通过openid换取用户信息
        axios.get("openid/info?type=1&openid=" + response.data.openid).then(function (response) {
          //已注册用户
          if (response.data.errcode == 0) {
            localStorage.user = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.data);
            next();
          } else {
            //未注册用户
            if (to.path.indexOf("/home") > -1) {
              next({
                path: "/register"
              });
            }
          }
          next();
        });
      } else {
        var url = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxcdcdb6fe90c3615f&redirect_uri=https://node.chezhentong.com/m" + path + "&response_type=code&scope=snsapi_base&state=0#wechat_redirect";
        location.replace(url);
      }
    });
  } else {
    //无code有openid，获取用户信息
    if (localStorage.OpenId && localStorage.OpenId != "") {
      axios.get("openid/info?type=1&openid=" + localStorage.OpenId).then(function (response) {
        //已注册用户
        if (response.data.errcode == 0) {
          localStorage.user = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.data);
        } else {
          //未注册用户
          if (to.path.indexOf("/home") > -1) {
            next({
              path: "/register"
            });
          }
        }
        next();
      });
    } else {
      //无code，无openid
      var url = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxcdcdb6fe90c3615f&redirect_uri=https://node.chezhentong.com/m" + path + "&response_type=code&scope=snsapi_base&state=0#wechat_redirect";
      location.replace(url);
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(118)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(78),
  /* template */
  __webpack_require__(131),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(119)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(79),
  /* template */
  __webpack_require__(132),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3321db96",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 76:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__animation_es5__ = __webpack_require__(128);
//
//
//
//
//
//
//
//



var EaseOutEasing = __WEBPACK_IMPORTED_MODULE_0__animation_es5__["a" /* default */].EaseOutEasing,
    BounceEasing = __WEBPACK_IMPORTED_MODULE_0__animation_es5__["a" /* default */].BounceEasing,
    MomentumEasing = __WEBPACK_IMPORTED_MODULE_0__animation_es5__["a" /* default */].MomentumEasing,
    BoundMomentumEasing = __WEBPACK_IMPORTED_MODULE_0__animation_es5__["a" /* default */].BoundMomentumEasing;


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    values: {
      type: Array,
      default: []
    },
    length: {
      type: Number,
      default: 0
    },
    allValues: {
      type: Array
    },
    index: {
      type: Number,
      default: 0
    },
    itemIndex: {
      type: Number
    },
    keyName: {
      type: String,
      default: 'value'
    },
    maxScrollValue: {
      type: Number
    }
  },
  data: function data() {
    return {
      startValue: 0,
      startPageY: 0,
      scrollValue: 0,
      maxVelocity: 6,
      currentValues: this.values,
      currentMaxScrollValue: this.maxScrollValue,
      baseScrollValue: 0,
      firstTimeRequest: true,
      poolData: [],
      count: 0,
      requestStart: 0,
      lastValues: [],
      currentIndex: 0,
      isSend: true
    };
  },

  methods: {
    onPanStart: function onPanStart() {
      var e = arguments.length <= 0 ? undefined : arguments[0];
      this.startPageY = e.changedPointers[0].pageY;
      this.startValue = this.scrollValue;
      this.bounceHelper.stop();
      this.bounce.stop();
      this.boundMomentum.stop();
    },
    onPanMove: function onPanMove() {
      var e = arguments.length <= 0 ? undefined : arguments[0];
      var deg = this.startValue - (e.changedPointers[0].pageY - this.startPageY);
      var oldDeg = this.scrollValue;
      this.onScroll(deg, oldDeg);
      this.scrollValue = deg;
      this.isSend = true;
    },
    onPanEnd: function onPanEnd() {

      var e = arguments.length <= 0 ? undefined : arguments[0];
      var maxVelocity = this.maxVelocity;
      var velocity = e.velocityY;

      if (velocity < -maxVelocity) {
        velocity = -maxVelocity;
      } else if (velocity > maxVelocity) {
        velocity = maxVelocity;
      }

      this.maxMomentumValue = (this.currentMaxScrollValue - 1) * 18;

      var boundValue = null;

      if (this.scrollValue < 0) {

        boundValue = 0;
      } else if (this.scrollValue >= this.maxMomentumValue) {

        boundValue = this.maxMomentumValue;
      }

      if (boundValue !== null) {

        this.bounce.setConfig({
          startTime: Date.now(),
          startValue: this.scrollValue,
          endValue: boundValue
        });

        this.bounce.run();
        return;
      }

      this.boundMomentum.momentum.setConfig({
        startTime: Date.now(),
        startValue: this.scrollValue,
        startVelocity: velocity
      });

      this.boundMomentum.setConfig({
        maxMomentumValue: this.maxMomentumValue,
        startValue: this.scrollValue,
        startVelocity: velocity,
        callback: this.animationScrollValue
      });

      this.boundMomentum.run();
    },
    requestPoolData: function requestPoolData() {
      if (this.count + 3 >= this.requestStart * 5) {
        var data = this.allValues.slice(this.requestStart++ * 50, this.requestStart * 50),
            length = 0;
        if (data instanceof Array) {
          data = data.slice(0, 50);
          this.poolData = this.poolData.concat(data);
        }
      }
    },
    onScroll: function onScroll(value, oldValue) {

      this.setAlpha(value);

      this.currentIndex = Math.round(value / 18);

      var data = void 0,
          helperData = void 0,
          countHelper = void 0;

      if (value >= oldValue) {
        if (value - this.baseScrollValue > 90) {
          if (this.firstTimeRequest) {
            this.requestPoolData();
            this.firstTimeRequest = false;
          }
          this.baseScrollValue += 90;
          data = this.poolData.slice(15 + this.count++ * 5, 15 + this.count * 5);
          data.length = 5;
          helperData = this.lastValues;

          countHelper = (this.count + 2) % 4;
          countHelper += countHelper < 0 ? 4 : 0;

          Array.prototype.splice.apply(helperData, [5 * countHelper, 5].concat(data));

          this.currentValues = this.lastValues;
          this.lastValues = this.currentValues;
          this.requestPoolData();
        }
      } else {
        if (value < this.baseScrollValue) {
          if (this.firstTimeRequest) {
            this.requestPoolData();
            this.firstTimeRequest = false;
          }

          this.baseScrollValue -= 90;
          --this.count;
          data = this.count > 0 ? this.poolData.slice((this.count - 1) * 5, this.count * 5) : [];
          data.length = 5;
          helperData = this.lastValues;

          countHelper = (this.count - 1) % 4;
          countHelper += countHelper < 0 ? 4 : 0;

          Array.prototype.splice.apply(helperData, [5 * countHelper, 5].concat(data));

          this.currentValues = this.lastValues;
          this.lastValues = this.currentValues;
        }
      }
    },
    setAlpha: function setAlpha(deg) {
      var spans = this.$refs.pickerItemContent.querySelectorAll('span');
      var index = Math.round(deg / 18) % 20;
      deg = deg % 360;
      deg = deg < 0 ? deg + 360 : deg;
      for (var i = 0; i < spans.length; i++) {
        var dis = Math.abs(i * 18 - deg);
        var n = Math.abs(1 - dis / 18 * 0.1);
        spans[i].style.opacity = Math.abs(n - 0.5);
        spans[index] && (spans[index].style.opacity = 1);
      }
    },
    animationScrollValue: function animationScrollValue(value, isEnd) {
      var deg = value;
      var oldDeg = this.scrollValue;
      this.onScroll(deg, oldDeg);
      this.scrollValue = value;
    },
    initAnimation: function initAnimation() {
      var _this = this;

      this.boundMomentum = new BoundMomentumEasing();
      this.boundMomentumIsEndedFn = this.boundMomentum.isEnded;
      this.bounceHelper = new EaseOutEasing();
      this.bounce = new EaseOutEasing();

      var boundMomentum = this.boundMomentum;
      var bounce = this.bounce;
      var bounceHelper = this.bounceHelper;

      boundMomentum.momentum.setConfig({
        acceleration: 30,
        friction: 1
      });
      boundMomentum.bounce.setConfig({
        acceleration: 30
      });
      boundMomentum.setConfig({
        minVelocity: 1,
        minMomentumValue: 0,
        callback: this.animationScrollValue
      });

      bounce.setConfig({
        duration: 400,
        callback: this.animationScrollValue
      });
      bounceHelper.setConfig({
        duration: 400,
        callback: this.animationScrollValue
      });

      boundMomentum.isEnded = function () {

        var result = _this.boundMomentumIsEndedFn.call(boundMomentum);

        if (!boundMomentum.isOutOfBound && result) {
          animationScrollValueHelper();
        }
        return result;
      };

      var animationScrollValueHelper = function animationScrollValueHelper() {

        var scrollValue = Math.round(_this.scrollValue / 18);
        var supplyValue = scrollValue * 18 - _this.scrollValue;

        bounceHelper.setConfig({
          startTime: Date.now(),
          startValue: _this.scrollValue,
          endValue: _this.scrollValue + supplyValue
        });

        bounceHelper.run();
      };
    }
  },
  mounted: function mounted() {
    this.lastValues = this.currentValues;
    this.setAlpha(0);
    this.initAnimation();
    var defaultValue = this.index * 18;

    if (!defaultValue) {
      this.$emit('change', this.itemIndex, this.allValues[0], false);
      return;
    }

    for (var i = 0; i <= defaultValue; i += 18) {
      this.onScroll(i, this.scrollValue);
      this.scrollValue = i;
      this.isSend = false;
    }
  },

  watch: {
    allValues: function allValues(newAllValues) {
      this.setAlpha(0);
      this.scrollValue = 0;
      this.firstTimeRequest = true;
      this.baseScrollValue = 0;
      this.firstTimeRequest = true;
      this.poolData = [];
      this.count = 0;
      this.currentIndex = 0;
      this.requestStart = 0;
      this.currentValues = newAllValues.slice(0, 15);
      this.lastValues = this.currentValues;
      this.currentMaxScrollValue = newAllValues.length;
      this.$emit('change', this.itemIndex, newAllValues[0], true);
    },
    currentIndex: function currentIndex(newIndex, oldIndex) {
      var result = this.allValues[newIndex];
      if (result) {
        this.$emit('change', this.itemIndex, result, this.isSend);
      }
    },
    maxScrollValue: function maxScrollValue(newValue, oldValue) {
      this.currentMaxScrollValue = newValue;
      newValue = newValue - 1;
      if (newValue > this.currentIndex) {
        return;
      }
      this.bounceHelper.stop();
      this.bounce.stop();
      this.boundMomentum.stop();

      this.bounceHelper.setConfig({
        startTime: Date.now(),
        startValue: this.scrollValue,
        endValue: newValue * 18
      });

      this.bounceHelper.run();
    },
    index: function index(newIndex, oldIndex) {
      var targetValue = newIndex * 18;
      var currentValue = this.scrollValue;
      this.isSend = true;
      if (this.scrollValue > targetValue) {
        for (var i = currentValue; i >= targetValue; i -= 18) {
          this.onScroll(i, this.scrollValue);
          this.scrollValue = i;
        }
      } else {
        for (var _i = currentValue; _i <= targetValue; _i += 18) {
          this.onScroll(_i, this.scrollValue);
          this.scrollValue = _i;
        }
      }
    }
  }
});

/***/ }),

/***/ 77:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raf_js__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raf_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_raf_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_touch__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__picker_item_vue__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__picker_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__picker_item_vue__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_touch___default.a, { name: 'touch' });

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].directive('for-nested', {
  bind: function bind(el, binding) {
    var value = binding.value[0];
    var key = binding.value[1];
    var html = '';
    for (var i = 0; i < 20; i++) {
      var n = 19 - i;
      var item = null;
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(value[n]) == 'object') {
        item = value[n] && typeof value[n][key] !== 'undefined' ? value[n][key] : '';
      } else {
        item = typeof value[n] !== 'undefined' ? value[n] : '';
      }
      html = '<div><span data-index="' + n + '">' + item + '</span>' + html + '</div>';
    }
    el.innerHTML = html;
  },
  update: function update(el, binding) {
    var value = binding.value[0];
    var key = binding.value[1];
    var spenEl = el.querySelectorAll('span');
    var length = spenEl.length;
    for (var i = 0; i < length; i++) {
      var item = null;
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(value[i]) == 'object') {
        item = value[i] && typeof value[i][key] !== 'undefined' ? value[i][key] : '';
      } else {
        item = typeof value[i] !== 'undefined' ? value[i] : '';
      }
      spenEl[i].innerHTML = item;
    }
  }
});

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'picker',
  components: {
    'picker-item': __WEBPACK_IMPORTED_MODULE_5__picker_item_vue___default.a
  },
  data: function data() {
    return {
      result: [],
      flex: {
        '-webkit-box-flex': 'initial',
        '-ms-flex': 'initial',
        'flex': 'initial'
      }
    };
  },

  props: {
    value: {
      type: Boolean
    },
    dataItems: {
      type: Array
    },
    callbackArg: {}
  },
  methods: {
    onClose: function onClose() {
      var e = arguments.length <= 0 ? undefined : arguments[0];
      if (e.target && e.target.classList.contains('picker-backdrop')) {
        this.$emit('input', false);
      }
    },
    onChangeValue: function onChangeValue(itemIndex, result, isSend) {
      if (isSend) {
        this.result[itemIndex] = result;
        this.$emit.apply(this, ['change'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.result), [this.callbackArg]));
      } else {
        this.result[itemIndex] = result;
      }
    },
    init: function init(n) {
      __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].set(n, 'key', n.name);
      if (n.width) {
        var width = { 'width': n.width };
        __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].set(n, 'style', [width, this.flex]);
      }
      if (!n.maxScrollValue) {
        __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].set(n, 'maxScrollValue', n.values.length);
      }
      n.$value = n.values.slice(0, 15);
    }
  },
  watch: {
    dataItems: function dataItems(newDataItems) {
      newDataItems.forEach(this.init);
    },
    value: function value(result) {
      if (!result) return;
      this.$emit.apply(this, ['change'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.result), [this.callbackArg]));
    }
  },
  created: function created() {
    this.dataItems.forEach(this.init);
  }
});

/***/ }),

/***/ 78:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 79:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "loading",
  data: function data() {
    return {};
  },

  props: {
    showLoading: {
      type: Boolean,
      required: false,
      default: true
    }
  }
});

/***/ }),

/***/ 80:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_3d_picker__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_3d_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_3d_picker__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_3d_picker___default.a);

//axios全局配置
window.axios = __WEBPACK_IMPORTED_MODULE_3_axios___default.a;
// 为避免白屏，取消超时设置。
// axios.defaults.timeout = 10000
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8";
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.baseURL = "https://node.chezhentong.com/api/"; //接口地址
// axios.defaults.baseURL = 'https://t.api.chezhentong.com/api/'; //测试接口地址

//网关层异常监听
window.addEventListener("unhandledrejection", function (event) {
  var errorURL = event.reason.request.responseURL;
  if (errorURL.indexOf("h5.chezhentong.com") != -1) {} else {
    //日志上报
    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://h5.chezhentong.com/v2/api/logs/czt-web", {
      type: "网络层面",
      error: event.reason,
      userAgent: navigator.userAgent,
      OpenId: localStorage.OpenId ? localStorage.OpenId : "",
      url: window.location.href,
      errorURL: errorURL
    }).then(function (response) {});
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.errorHandler = function (err, vm, info) {
  __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://h5.chezhentong.com/v2/api/logs/czt-web", {
    type: "代码层面",
    error: err.stack,
    userAgent: navigator.userAgent,
    OpenId: localStorage.OpenId ? localStorage.OpenId : "",
    url: window.location.href
  }).then(function (response) {});
};
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: "#app",
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: "<App/>",
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ })

},[80]);


// WEBPACK FOOTER //
// app.1491.js